"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startPageTiming = exports.INTERVAL_SEND_TIME_MS = void 0;
var timeme_js_1 = __importDefault(require("timeme.js"));
var Util_1 = require("./Util");
var luxon_1 = require("luxon");
var EventFactory_1 = require("./EventFactory");
var BlockViewTracker_1 = __importDefault(require("./BlockViewTracker"));
var Sentry = __importStar(require("@sentry/browser"));
var analytics_1 = require("../Common/Utils/analytics");
var USER_IDLE_TIMEOUT = 60;
var REFRESH_TRIGGERING_IDLE_DURATION = luxon_1.Duration.fromISO("PT24H");
exports.INTERVAL_SEND_TIME_MS = 5000;
var PageTimerState = (function () {
    function PageTimerState() {
    }
    PageTimerState.startNewTimeSpan = function () {
        PageTimerState.currentViewWindow.start = luxon_1.DateTime.now();
        PageTimerState.currentViewWindow.end = undefined;
        PageTimerState.userWentIdleTimestamp = undefined;
    };
    PageTimerState.stopSpan = function () {
        console.log("Stopping time span");
        PageTimerState.currentViewWindow.start = undefined;
        PageTimerState.currentViewWindow.end = undefined;
    };
    PageTimerState.getMillisOnCurrentView = function () {
        if (!PageTimerState.currentViewWindow.end) {
            PageTimerState.currentViewWindow.end = luxon_1.DateTime.now();
        }
        if (!PageTimerState.currentViewWindow.start) {
            PageTimerState.currentViewWindow.start = luxon_1.DateTime.now();
        }
        var endMillis = PageTimerState.currentViewWindow.end.toMillis();
        var startMillis = PageTimerState.currentViewWindow.start.toMillis();
        return (0, Util_1.capDuration)(endMillis - startMillis);
    };
    PageTimerState.currentViewWindow = {
        start: undefined,
        end: undefined,
    };
    PageTimerState.userWentIdleTimestamp = undefined;
    return PageTimerState;
}());
var sendPageDuration = function (eventSender, pageInfo, duration, durationChange) { return __awaiter(void 0, void 0, Promise, function () {
    var pageDurationEvent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pageDurationEvent = EventFactory_1.PageAnalyticsEventFactory.buildPageViewDurationEvent(pageInfo, duration, durationChange);
                return [4, eventSender.send([pageDurationEvent])];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
var shouldTriggerNewVisit = function (userWentIdleTimestamp) {
    if (!!userWentIdleTimestamp) {
        console.log("User went idle at ".concat(userWentIdleTimestamp === null || userWentIdleTimestamp === void 0 ? void 0 : userWentIdleTimestamp.toISO()));
        console.log("Diff is ".concat(luxon_1.DateTime.now().diff(userWentIdleTimestamp), " millis"));
        return luxon_1.DateTime.now().diff(userWentIdleTimestamp) > REFRESH_TRIGGERING_IDLE_DURATION;
    }
    return false;
};
var startInterval = function (eventSender, pageInfo) {
    PageTimerState.currentTimerId = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    if (!timeme_js_1.default.isUserCurrentlyOnPage) return [3, 2];
                    return [4, sendPageDuration(eventSender, pageInfo, (0, Util_1.millisOnPage)(), PageTimerState.getMillisOnCurrentView())];
                case 1:
                    _a.sent();
                    BlockViewTracker_1.default.snapshotBlockTimings();
                    return [3, 3];
                case 2:
                    BlockViewTracker_1.default.stop();
                    _a.label = 3;
                case 3: return [3, 6];
                case 4:
                    err_1 = _a.sent();
                    (0, Util_1.handleError)(err_1);
                    return [3, 6];
                case 5:
                    PageTimerState.startNewTimeSpan();
                    return [7];
                case 6: return [2];
            }
        });
    }); }, exports.INTERVAL_SEND_TIME_MS);
};
var stopInterval = function () {
    clearInterval(PageTimerState.currentTimerId);
};
var setSentryContext = function (pageInfo) {
    Sentry.setContext("PageTiming", {
        viewId: pageInfo.pageViewId,
        pageId: pageInfo.pageId,
        pageName: pageInfo.pageName,
        pageUserId: pageInfo.userId,
        visitToken: pageInfo.visitToken,
    });
    Sentry.setTag("view_id", pageInfo.pageViewId);
};
var startPageTiming = function (eventSender) {
    var pageInfo = (0, Util_1.getPageTrackingInfo)(window);
    if (!pageInfo) {
        console.log("Page qSessionTracking empty, not tracking timings");
        return;
    }
    timeme_js_1.default.initialize({
        currentPageName: pageInfo.pageName,
        idleTimeoutInSeconds: USER_IDLE_TIMEOUT,
    });
    setSentryContext(pageInfo);
    PageTimerState.startNewTimeSpan();
    timeme_js_1.default.callWhenUserLeaves(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    console.log("User left page ".concat(pageInfo.pageName), (0, Util_1.millisOnPage)());
                    stopInterval();
                    PageTimerState.userWentIdleTimestamp = luxon_1.DateTime.now();
                    return [4, sendPageDuration(eventSender, pageInfo, (0, Util_1.millisOnPage)(), PageTimerState.getMillisOnCurrentView())];
                case 1:
                    _a.sent();
                    return [3, 4];
                case 2:
                    err_2 = _a.sent();
                    (0, Util_1.handleError)(err_2);
                    return [3, 4];
                case 3:
                    PageTimerState.stopSpan();
                    BlockViewTracker_1.default.stop();
                    return [7];
                case 4: return [2];
            }
        });
    }); });
    timeme_js_1.default.callWhenUserReturns(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                console.log("User returned to page ".concat(pageInfo.pageName), (0, Util_1.millisOnPage)());
                if (shouldTriggerNewVisit(PageTimerState.userWentIdleTimestamp)) {
                    console.log("Should trigger new view after ".concat(REFRESH_TRIGGERING_IDLE_DURATION.toISO()));
                }
                PageTimerState.startNewTimeSpan();
                startInterval(eventSender, pageInfo);
                BlockViewTracker_1.default.start();
            }
            catch (err) {
                (0, Util_1.handleError)(err);
            }
            return [2];
        });
    }); });
    console.log("Starting page tracking on view ".concat((0, analytics_1.getPageViewId)(window), " - ").concat(luxon_1.DateTime.now().toISO()));
    startInterval(eventSender, pageInfo);
    BlockViewTracker_1.default.init(eventSender);
    BlockViewTracker_1.default.start();
};
exports.startPageTiming = startPageTiming;
